var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.2501V10.8319C20.25 10.7274 20.2282 10.624 20.1859 10.5284C20.1436 10.4329 20.0818 10.3472 20.0045 10.2769L12.504 3.45799C12.3659 3.33248 12.186 3.26293 11.9995 3.26294C11.8129 3.26295 11.633 3.3325 11.4949 3.45803L3.99545 10.2769C3.91814 10.3472 3.85637 10.4329 3.8141 10.5284C3.77183 10.624 3.75 10.7273 3.75 10.8318V20.2501",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.2501V10.8319C20.25 10.7274 20.2282 10.624 20.1859 10.5284C20.1436 10.4329 20.0818 10.3472 20.0045 10.2769L12.504 3.45799C12.3659 3.33248 12.186 3.26293 11.9995 3.26294C11.8129 3.26295 11.633 3.3325 11.4949 3.45803L3.99545 10.2769C3.91814 10.3472 3.85637 10.4329 3.8141 10.5284C3.77183 10.624 3.75 10.7273 3.75 10.8318V20.2501",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 20.2493V14.9993C14.2495 14.8004 14.1705 14.6096 14.0298 14.4689C13.8892 14.3283 13.6984 14.2493 13.4995 14.2493H10.4995C10.3006 14.2493 10.1098 14.3283 9.96918 14.4689C9.82853 14.6096 9.74951 14.8004 9.74951 14.9993V20.2493",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 20.2493V14.9993C14.2495 14.8004 14.1705 14.6096 14.0298 14.4689C13.8892 14.3283 13.6984 14.2493 13.4995 14.2493H10.4995C10.3006 14.2493 10.1098 14.3283 9.96918 14.4689C9.82853 14.6096 9.74951 14.8004 9.74951 14.9993V20.2493",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.25H22.5",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.7e9a820f1194987bea80e9b947efc90b.svg";
export { ForwardRef as ReactComponent };